export default {
  name: 'messages',
  getInfo: {
    url: '/magazine/userCenter/systemMessage/unReadMessage.do'
  }
}
